import { themed } from '@indeed/ifl-css';

const CARD_SECTION_DEFAULT_TAG = "div";
const CardSection = /*#__PURE__*/themed(CARD_SECTION_DEFAULT_TAG, process.env.NODE_ENV === "production" ? {
  styleProps: ["full"],
  shouldForwardProp: prop => prop !== "full",
  target: "e1gufzzf0"
} : {
  styleProps: ["full"],
  shouldForwardProp: prop => prop !== "full",
  target: "e1gufzzf0",
  label: "CardSection"
})(_ref => {
  let {
    full = false
  } = _ref;
  return [full ? {
    paddingInline: 0,
    paddingBlock: 0
  } : {
    paddingInlineStart: 4,
    paddingInlineEnd: 4,
    paddingBlockEnd: 4,
    paddingBlockStart: 4,
    ":first-of-type:not(:only-of-type)": {
      paddingBlockEnd: 0
      // Remove bottom padding for the first section (header) unless it is the only section
    },
    ":not(:first-of-type, :nth-of-type(2))": {
      paddingBlockStart: 0
      // Remove top padding for all sections >= 3 (anything after the body)
    }
  }];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmRTZWN0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQjJCIiwiZmlsZSI6IkNhcmRTZWN0aW9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHRoZW1lZCwgU3R5bGVQcm9wcyB9IGZyb20gXCJAaW5kZWVkL2lmbC1jc3NcIjtcblxuaW1wb3J0ICogYXMgUG9seW1vcnBoaWMgZnJvbSBcIi4uLy4uL3R5cGVzL3BvbHltb3JwaGljXCI7XG5cbmV4cG9ydCBjb25zdCBDQVJEX1NFQ1RJT05fREVGQVVMVF9UQUcgPSBcImRpdlwiO1xuXG5leHBvcnQgaW50ZXJmYWNlIENhcmRTZWN0aW9uUHJvcHMgZXh0ZW5kcyBTdHlsZVByb3BzIHtcbiAgLyoqXG4gICAqIFVzZWQgdG8gcHJvdmlkZSBhIGZ1bGwtYmxlZWQgYnkgcmVtb3ZpbmcgdGhlIGRlZmF1bHQgcGFkZGluZy5cbiAgICovXG4gIGZ1bGw/OiBib29sZWFuO1xufVxuXG5leHBvcnQgdHlwZSBDYXJkU2VjdGlvbkNvbXBvbmVudCA9IFBvbHltb3JwaGljLkNvbXBvbmVudDxcbiAgdHlwZW9mIENBUkRfU0VDVElPTl9ERUZBVUxUX1RBRyxcbiAgQ2FyZFNlY3Rpb25Qcm9wc1xuPjtcblxuZXhwb3J0IGNvbnN0IENhcmRTZWN0aW9uID0gdGhlbWVkKENBUkRfU0VDVElPTl9ERUZBVUxUX1RBRywge1xuICBzdHlsZVByb3BzOiBbXCJmdWxsXCJdLFxuICBzaG91bGRGb3J3YXJkUHJvcDogKHByb3A6IHN0cmluZyk6IGJvb2xlYW4gPT4gcHJvcCAhPT0gXCJmdWxsXCJcbn0pPENhcmRTZWN0aW9uUHJvcHM+KCh7IGZ1bGwgPSBmYWxzZSB9KSA9PiBbXG4gIGZ1bGxcbiAgICA/IHtcbiAgICAgICAgcGFkZGluZ0lubGluZTogMCxcbiAgICAgICAgcGFkZGluZ0Jsb2NrOiAwXG4gICAgICB9XG4gICAgOiB7XG4gICAgICAgIHBhZGRpbmdJbmxpbmVTdGFydDogNCxcbiAgICAgICAgcGFkZGluZ0lubGluZUVuZDogNCxcbiAgICAgICAgcGFkZGluZ0Jsb2NrRW5kOiA0LFxuICAgICAgICBwYWRkaW5nQmxvY2tTdGFydDogNCxcbiAgICAgICAgXCI6Zmlyc3Qtb2YtdHlwZTpub3QoOm9ubHktb2YtdHlwZSlcIjoge1xuICAgICAgICAgIHBhZGRpbmdCbG9ja0VuZDogMFxuICAgICAgICAgIC8vIFJlbW92ZSBib3R0b20gcGFkZGluZyBmb3IgdGhlIGZpcnN0IHNlY3Rpb24gKGhlYWRlcikgdW5sZXNzIGl0IGlzIHRoZSBvbmx5IHNlY3Rpb25cbiAgICAgICAgfSxcbiAgICAgICAgXCI6bm90KDpmaXJzdC1vZi10eXBlLCA6bnRoLW9mLXR5cGUoMikpXCI6IHtcbiAgICAgICAgICBwYWRkaW5nQmxvY2tTdGFydDogMFxuICAgICAgICAgIC8vIFJlbW92ZSB0b3AgcGFkZGluZyBmb3IgYWxsIHNlY3Rpb25zID49IDMgKGFueXRoaW5nIGFmdGVyIHRoZSBib2R5KVxuICAgICAgICB9XG4gICAgICB9XG5dKSBhcyBDYXJkU2VjdGlvbkNvbXBvbmVudDtcblxuQ2FyZFNlY3Rpb24uZGlzcGxheU5hbWUgPSBcIkNhcmRTZWN0aW9uXCI7XG4iXX0= */");
CardSection.displayName = "CardSection";

export { CARD_SECTION_DEFAULT_TAG, CardSection };
